<template>
  <div>
    <stepper
      class="form-group--inset"
      :value="adultCount"
      :min="1"
      :max="9 - childCount"
      label="Adults"
      sublabel="17+ years old"
      @input="handlePassengerChange('adults', $event)"
    />
    <spacer :spacing="20" />
    <stepper
      class="form-group--inset"
      :value="childCount"
      :min="0"
      :max="9 - adultCount"
      label="Children"
      sublabel="0 - 16 years old"
      @input="handlePassengerChange('children', $event)"
    />
    <spacer :spacing="20" />
    <div v-if="hasChildren" class="tgmag-searchwidget__group-details">
      <strong>How old are the children travelling?</strong>
      <p>We’ll use this to give accurate price information.</p>
      <Passenger
        v-for="(v, index) in children"
        :key="index"
        grouping="children"
        :value="v"
        @input="updatePassenger('children', index, $event)"
        class="tgmag-searchwidget__agelist form-group--inset"
      />
    </div>
  </div>
</template>
<script>
import Spacer from "../Utilities/Spacer.vue";
import Stepper from "../Stepper";
import Passenger from "../Passenger";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "Passengers",
  components: {
    Passenger,
    Spacer,
    Stepper
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
      validator(value) {
        return value.every(entity =>
          Object.prototype.hasOwnProperty.call(entity, "age")
        );
      }
    },
    minAdultAge: {
      type: Number,
      default: 17,
      validator(value) {
        return value >= 0;
      }
    }
  },
  data() {
    return {
      passengers: [],
      children: [],
      adults: []
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.passengers = value;
        this.adults = value.filter(passenger => this.isAdult(passenger.age));
        this.children = value.filter(passenger => this.isChild(passenger.age));
      }
    }
  },
  validations: {
    children: {
      $each: {
        age: {
          required,
          numeric
        }
      }
    }
  },
  computed: {
    adultCount() {
      return this.adults.length;
    },
    childCount() {
      return this.children.length;
    },
    hasChildren() {
      return this.children.length > 0;
    }
  },
  methods: {
    updatePassenger(grouping, index, value) {
      this.$set(this[grouping], index, value);
      this.updatePassengers(grouping);
    },
    handlePassengerChange(grouping, value) {
      if (value === 0) {
        this[grouping] = JSON.parse("[]");
      } else if (this[grouping].length < value) {
        for (let i = 0; i < value - (this[grouping].length - 1); i++) {
          if (grouping === "children") {
            this[grouping].push({ age: "" });
          } else {
            this[grouping].push({ age: null });
          }
        }
      } else if (this[grouping].length > value) {
        this[grouping].splice(-1, value);
      }
      this.updatePassengers();
    },
    updatePassengers() {
      this.passengers = [].concat(this.adults, this.children);
      this.$v.$touch();
      // if (!this.$v.$invalid) {
      this.$emit("input", this.passengers);
      // }
    },
    isChild(age) {
      return Number.isNaN(age) || (age !== null && age < this.minAdultAge);
    },
    isAdult(age) {
      return age === null || age >= this.minAdultAge;
    }
  }
};
</script>
